module.exports = __webpack_public_path__ + "static/img/MTI-Economy-D-小胖哥.24331ddd.jpg";